import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconClose } from '../icons/svg';

export default class Alert extends React.PureComponent {

  componentDidMount() {
    document.addEventListener('keydown', e => {
      if (e.key === "Escape" || e.keyCode === 27) {
        this.props.onClose();
      }
    })
  }
  render() {
    return (
      <div className="alert-container">
        <div className="alert">
          <div className="header">
            <div className="title">{this.props.title}</div>
            <div className="icon" onClick={this.props.onClose}><IconClose /></div>
          </div>
          <div className="content">{this.props.content}</div>
          <div className="dialog-buttons">
            {this.props.onReject ?
              <button className="button-cancel" onClick={this.props.onReject}>
                {this.props.reject || <FormattedMessage id="button_cancel" defaultMessage="Cancel" description="Button [Cancel]" />}
              </button>
              :
              null
            }
            {this.props.onConfirm ?
              <button className="button-ok" onClick={this.props.onConfirm}>
                {this.props.confirm || <FormattedMessage id="button_ok" defaultMessage="OK" description="Button [OK]" />}
              </button>
              :
              null
            }
          </div>
        </div>
      </div>
    );
  }
};
